import React from 'react'

export const Error = () => <p>500</p>

export default Error
